<template>
  <report-form
    v-model="payload"
    :page-title="$t('app.reports.inadimplentes.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Reports"
    navigate-page-after-save="Reports"
  >
    <template slot="group-1">
      <form-group :title="$t('app.reports.subtitle')">
        <v-flex
          xs12
          lg6
        >
          <date-interval
            id="dateInterval"
            v-model="payload.period"
            identifier="period"
          />
          <money-interval
            id="moneyInterval"
            v-model="payload.money"
            identifier="money"
          />
          <formats-autocomplete
            id="formatsAutocomplete"
            v-model="payload.format"
          />
        </v-flex>
      </form-group>
    </template>
  </report-form>
</template>

<script>
import DateInterval from 'Support/components/reports/DateInterval.vue';
import MoneyInterval from 'Support/components/reports/MoneyInterval.vue';
import FormatsAutocomplete from 'Support/components/reports/FormatsAutocomplete.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import InadimplentesRequest from 'Domain/reports/InadimplentesRequest';
import ReportForm from 'Support/components/reports/ReportForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import ReportMixin from 'Support/mixins/ReportMixin';

export default {
  name: 'InadimplentesReport',
  components: {
    ReportForm,
    FormGroup,
    MoneyInterval,
    DateInterval,
    FormatsAutocomplete,
  },
  mixins: [RulesMixin, ReportMixin],
  data: () => ({
    requestClass: InadimplentesRequest,
    payload: {
      money: {
        initialValue: '',
        finalValue: '',
      },
      period: {
        dataInicial: '',
        dataFinal: '',
      },
      format: 'PDF',
    },
  }),
};
</script>
